"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { Content } from "@/lib/getDocumentsAndDeliverables";
import DocumentTransaltionPricing2cards from "./Document-translation-pricing-2cards";
import DocumentTranslationPricing3cards from "./Document-translation-pricing-3cards";

type DocumentCertifiedBlockProps = {
  content: Content;
};

export default function DocumentTransaltionPricingAllVariants({
  content,
}: DocumentCertifiedBlockProps) {
  const translationServiceTitle = content.translationServiceTitle;
  const translationServiceDescription = content.translationServiceDescription;

  return (
    <>
      <DocumentTranslationPricing3cards
        title={translationServiceTitle}
        description={translationServiceDescription}
      />
    </>
  );
}
